import cn from 'classnames';
import * as React from 'react';

import Text from '../text';
import VisuallyButton from '../visually-button';

import { Message as Props, themes } from './message.types';

const Message: React.FC<Props> & {
  themes: typeof themes;
} = ({ action, inline, link, mini, text, theme = themes.default }) => (
  <div
    className={cn('message', {
      'message--floating': !inline,
      'message--inline': inline,
      'message--mini': mini,
      [`message--theme-${theme}`]: theme,
    })}
  >
    <div
      className={cn('message__main', {
        'message--has-button': action,
      })}
    >
      <div>
        <Text
          className="message__text"
          size={mini ? Text.sizes.small : Text.sizes.basic}
        >
          {text}
        </Text>
        {link ? (
          <div className="message__link-container">
            <Text
              className="message__link"
              elementName="a"
              href={link.href}
              size={mini ? Text.sizes.small : Text.sizes.basic}
            >
              {link.text}
            </Text>
          </div>
        ) : null}
      </div>
    </div>
    {action ? (
      <div>
        <VisuallyButton
          {...action}
          size={VisuallyButton.sizes.small}
          variant={VisuallyButton.variants.secondary}
        />
      </div>
    ) : null}
  </div>
);

Message.themes = themes;

export default Message;
